// app-context-bridge.ts
import { AppContextType } from "./app-context";

let appContextRef: AppContextType | null = null;

export const setAppContextRef = (ctx: AppContextType) => {
  appContextRef = ctx;
};

export const getAppContextRef = () => appContextRef;
